var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c(_vm.mode,{tag:"component",attrs:{"user":_vm.user},on:{"switch-mode":function($event){_vm.mode = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }